import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_NEW_COACHES} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewOrganizationCoachesContent} from './NewOrganizationCoachesContent';
import reportPayload from './reportPayload';

export const NewOrganizationCoachesReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'New Organization Coaches')}
      description={tt(
        'description',
        'All new Coaches added to your organization this month.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewOrganizationCoachesContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newOrganizationCoaches'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_NEW_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts(
          'reportRecordTitle.newOrganizationCoaches',
          'New Organization Coaches',
        ),
    },
  }),
)(NewOrganizationCoachesReport);
